import React from "react";
import { Box, Typography, Button } from "@mui/material";
import Tag from "./Tag";
import GitHubIcon from '@mui/icons-material/GitHub';
import WebIcon from '@mui/icons-material/Web';

const ProjectCard = ( props ) => {
    const { title, tags, description, url, github, imgUrl} = props;

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: {xs: 'column', md: 'row'},
            border: '1px solid rgba(148, 163, 184, 0.2)',
            borderRadius: '16px',
            backgroundColor: '#ffffff',
            overflow: 'hidden',
            margin: '1.5rem 0',
            boxShadow: '0 4px 6px rgba(0,0,0,0.07)',
            transition: 'all 0.3s ease',
            '&:hover': {
                boxShadow: '0 20px 25px rgba(0,0,0,0.1)',
                transform: 'translateY(-4px)'
            }
        }}>
            <Box
                component='img'
                alt='Project Image'
                src={imgUrl || '/static/placeholder-project.jpg'}
                sx={{
                    width: {xs: '100%', md: '50%'},
                    height: {xs: '200px', md: 'auto'},
                    objectFit: 'cover',
                    transition: 'transform 0.3s ease',
                    '&:hover': {
                        transform: 'scale(1.05)'
                    }
                }}
            />
            <Box sx={{
                padding: '1.5rem',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                width: '100%'
            }}>
                <Typography variant="h3" sx={{
                    fontWeight: 700,
                    fontSize: '1.5rem',
                    color: '#0f172a',
                    marginBottom: '0.75rem'
                }}>{title}</Typography>
                <Box sx={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', marginBottom: '1rem'}}>
                    {tags.map(ele => (
                        <Tag key={`${title}|${ele}`} name={ele}/>
                    ))}
                </Box>
                <Typography variant="body" sx={{
                    color: '#475569',
                    lineHeight: 1.7,
                    marginBottom: '1.25rem'
                }}>
                    {description}
                </Typography>
                <Box sx={{display: 'flex', flexDirection: 'row', gap: '0.75rem'}}>
                    {github ?
                    <Button
                        variant="outlined"
                        component="a"
                        href={github}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            borderColor: '#3b82f6',
                            color: '#3b82f6',
                            fontWeight: 600,
                            padding: '0.5rem 1rem',
                            textTransform: 'none',
                            borderRadius: '8px',
                            '&:hover': {
                                borderColor: '#1d4ed8',
                                backgroundColor: 'rgba(59, 130, 246, 0.08)',
                                color: '#1d4ed8'
                            }
                        }}
                    >
                        <GitHubIcon sx={{marginRight: '0.5rem'}}/>
                        GitHub
                    </Button>
                    : null}
                    {url ?
                    <Button
                        variant="contained"
                        component="a"
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            backgroundColor: '#3b82f6',
                            color: 'white',
                            fontWeight: 600,
                            padding: '0.5rem 1rem',
                            textTransform: 'none',
                            borderRadius: '8px',
                            boxShadow: '0 2px 8px rgba(59, 130, 246, 0.3)',
                            '&:hover': {
                                backgroundColor: '#1d4ed8',
                                boxShadow: '0 4px 12px rgba(59, 130, 246, 0.4)'
                            }
                        }}
                    >
                        <WebIcon sx={{marginRight: '0.5rem'}} />
                        Visit
                    </Button>
                    : null}
                </Box>
            </Box>
        </Box>
    );
};

export default ProjectCard;
